/**
 * Used for global styles, all other styles are declared at
 * the component level
 */
import React from 'react';

import TypographyStyles from './typography-styles';

const GlobalCSS = () => (
  <>
    <TypographyStyles />
  </>
);

export default GlobalCSS;
